
// Infrastructure Layer: Media Generation Utilities

/**
 * Generates a consistent, deterministic AI image URL based on prompt and ID.
 * Uses Pollinations.ai (Flux Model).
 */
export const generateImage = (prompt: string, id: string, subject: string) => {
    if (!prompt) return "https://placehold.co/1024x1024/1e1b4b/FFFFFF?text=Generating...";
    
    // Create a deterministic seed based on subject + id hash
    const uniqueKey = `${subject}-${id}`;
    let hash = 0;
    for (let i = 0; i < uniqueKey.length; i++) {
        hash = ((hash << 5) - hash) + uniqueKey.charCodeAt(i);
        hash |= 0;
    }
    const seed = Math.abs(hash);
    
    // Optimization: Truncate prompt to prevent URL overflow, keeping key descriptors
    const shortPrompt = prompt.slice(0, 250); 
    
    // Subject-Specific Art Direction
    // This ensures Math looks like Math, and History looks like History.
    let style = "cute 3d render, pixar style, vibrant educational illustration, soft lighting, 8k, masterpiece"; // Default

    switch (subject) {
        case 'math':
            style = "blueprint aesthetic, isometric view, glowing geometry, neon lines, mathematical diagram, highly detailed, clean background";
            break;
        case 'history':
            style = "cinematic movie shot, historical reconstruction, dramatic lighting, detailed texture, epic atmosphere, national geographic style";
            break;
        case 'science':
            style = "scientific macro photography, cross-section, holographic overlay, laboratory lighting, clean glass texture, 8k detail";
            break;
        case 'art':
            style = "oil painting texture, thick brushstrokes, artistic composition, vibrant color palette, museum quality";
            break;
        case 'english':
        case 'chinese':
            style = "storybook illustration, warm colors, character focused, expressive faces, disney animation style";
            break;
        default:
            // Coding or others
            if (subject === 'coding') {
                style = "cyberpunk city, glowing matrix code, digital realm, neon blue and purple, futuristic data visualization";
            }
            break;
    }
    
    return `https://image.pollinations.ai/prompt/${encodeURIComponent(`${shortPrompt} ${style}`)}?width=1024&height=1024&nologo=true&seed=${seed}&model=flux`;
};
